import { render, staticRenderFns } from "./ApplicationFormLegalNotice.vue?vue&type=template&id=42abe1a8&scoped=true"
import script from "./ApplicationFormLegalNotice.vue?vue&type=script&lang=ts"
export * from "./ApplicationFormLegalNotice.vue?vue&type=script&lang=ts"
import style0 from "./ApplicationFormLegalNotice.vue?vue&type=style&index=0&id=42abe1a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42abe1a8",
  null
  
)

export default component.exports